/* ============================================================
   Due Date Calculator — Shopify Asset
   File: assets/due-date-calculator.js
   (mirrors LIVE logic incl. trimester product recommendations)
   v3.1: bottoms/jeans weighting raised in recommendations
   ============================================================ */

(function () {
  'use strict';

  window.ddcSwitchTab = function (name, el) {
    document.querySelectorAll('.ddc-tab').forEach(function (t) {
      t.classList.remove('ddc-tab--active');
      t.setAttribute('aria-selected', 'false');
    });
    document.querySelectorAll('.ddc-panel').forEach(function (p) {
      p.classList.remove('ddc-panel--active');
      p.hidden = true;
    });
    el.classList.add('ddc-tab--active');
    el.setAttribute('aria-selected', 'true');
    var panel = document.getElementById('panel-' + name);
    if (panel) { panel.classList.add('ddc-panel--active'); panel.hidden = false; }
    document.getElementById('ddc-result').hidden = true;
  };

  window.ddcCalculate = function (method) {
    var lmpDate = null;
    var today = new Date(); today.setHours(0, 0, 0, 0);

    if (method === 'lmp') {
      var d = document.getElementById('lmp-date').value;
      if (!d) { ddcAlert('Please select the first day of your last period.'); return; }
      var cycleAdj = parseInt(document.getElementById('cycle-len').value, 10) - 28;
      lmpDate = new Date(d + 'T00:00:00');
      lmpDate.setDate(lmpDate.getDate() + cycleAdj);
    } else if (method === 'conception') {
      var dc = document.getElementById('conception-date').value;
      if (!dc) { ddcAlert('Please enter your estimated conception date.'); return; }
      lmpDate = new Date(dc + 'T00:00:00');
      lmpDate.setDate(lmpDate.getDate() - 14);
    } else if (method === 'ivf') {
      var dt = document.getElementById('transfer-date').value;
      if (!dt) { ddcAlert('Please enter your embryo transfer date.'); return; }
      var embDay = parseInt(document.getElementById('embryo-day').value, 10);
      lmpDate = new Date(dt + 'T00:00:00');
      lmpDate.setDate(lmpDate.getDate() - (14 + embDay));
    } else if (method === 'ultrasound') {
      var du = document.getElementById('us-date').value;
      var uw = parseInt(document.getElementById('us-weeks').value, 10) || 0;
      var ud = parseInt(document.getElementById('us-days-input').value, 10) || 0;
      if (!du || (!uw && !ud)) { ddcAlert('Please enter both the ultrasound date and gestational age.'); return; }
      var scanDate = new Date(du + 'T00:00:00');
      lmpDate = new Date(scanDate);
      lmpDate.setDate(lmpDate.getDate() - (uw * 7 + ud));
    }

    var dueDate = new Date(lmpDate); dueDate.setDate(dueDate.getDate() + 280);
    var daysFromLmp = Math.floor((today - lmpDate) / 86400000);
    var daysLeft    = Math.floor((dueDate - today) / 86400000);
    var weeksPreg   = Math.floor(daysFromLmp / 7);
    var daysExtra   = daysFromLmp % 7;
    var pct         = Math.max(0, Math.min(100, Math.round((daysFromLmp / 280) * 100)));

    var opts = { year: 'numeric', month: 'long', day: 'numeric' };
    document.getElementById('ddc-result-date').textContent = dueDate.toLocaleDateString('en-US', opts);

    var weekEl = document.getElementById('ddc-result-week');
    if (daysFromLmp >= 0) {
      weekEl.innerHTML = '<strong>' + weeksPreg + 'w ' + daysExtra + 'd</strong>pregnant today';
    } else {
      weekEl.innerHTML = '<strong>\u2014</strong>Pre-pregnancy';
    }

    var trimester = weeksPreg < 14 ? 'First trimester' : weeksPreg < 28 ? 'Second trimester' : 'Third trimester';

    var add = function (base, days) {
      var nd = new Date(base); nd.setDate(nd.getDate() + days);
      return nd.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    };

    document.getElementById('ddc-milestones').innerHTML = [
      { label: 'Current week',      val: daysFromLmp >= 0 ? weeksPreg + 'w ' + daysExtra + 'd' : '\u2014',           sub: trimester },
      { label: 'Days to EDD',       val: daysLeft > 0 ? daysLeft + ' days' : daysLeft === 0 ? 'Today! \uD83C\uDF89' : Math.abs(daysLeft) + 'd overdue', sub: pct + '% complete' },
      { label: '2nd trimester',     val: add(lmpDate, 98),  sub: 'Week 14' },
      { label: '3rd trimester',     val: add(lmpDate, 196), sub: 'Week 28' },
      { label: 'Viability (24w)',   val: add(lmpDate, 168), sub: 'Week 24' },
      { label: 'Full term (39w)',   val: add(lmpDate, 273), sub: 'Week 39' },
    ].map(function (m) {
      return '<div class="ddc-milestone">'
        + '<div class="ddc-ms-label">' + m.label + '</div>'
        + '<div class="ddc-ms-val">' + m.val + '</div>'
        + '<div class="ddc-ms-sub">' + m.sub + '</div>'
        + '</div>';
    }).join('');

    if (daysFromLmp >= 0 && daysFromLmp <= 300) {
      document.getElementById('ddc-bar-fill').style.width = pct + '%';
      document.getElementById('ddc-bar-week-label').textContent = 'Week ' + weeksPreg;
      document.getElementById('ddc-bar-note').textContent = pct + '% of your pregnancy complete';
      document.getElementById('ddc-bar-wrap').style.display = 'block';
    } else {
      document.getElementById('ddc-bar-wrap').style.display = 'none';
    }

    var noteEl = document.getElementById('ddc-trimester-note');
    if (daysFromLmp >= 0) {
      noteEl.innerHTML = '<strong>' + trimester + '</strong> \u2014 You are approximately <strong>'
        + weeksPreg + ' weeks and ' + daysExtra + ' days</strong> pregnant. '
        + 'Estimated due date: <strong>' + dueDate.toLocaleDateString('en-US', opts) + '</strong>.';
    } else {
      noteEl.innerHTML = 'Your estimated due date is <strong>' + dueDate.toLocaleDateString('en-US', opts) + '</strong>.';
    }

    /* Product recommendations by trimester */
    var recsData = {
      t1: [
        { label: 'Maternity Leggings',  desc: 'Soft, stretchy leggings that grow with your bump.',         url: '/collections/maternity-leggings',   icon: '\uD83E\uDDF5' },
        { label: 'Maternity Jeans',     desc: 'Over-bump & under-bump denim, comfy from day one.',          url: '/collections/maternity-jeans',      icon: '\uD83D\uDC56' },
        { label: 'Maternity Tops',      desc: 'Comfortable & bump-friendly styles for early pregnancy.',   url: '/collections/maternity-tops',       icon: '\uD83D\uDC5A' },
        { label: 'Belly Bands',         desc: 'Extend your regular clothes a little longer.',              url: '/collections/belly-bands',          icon: '\uD83E\uDEF6' },
      ],
      t2: [
        { label: 'Maternity Jeans',     desc: 'Over-bump & under-bump fits for everyday comfort.',         url: '/collections/maternity-jeans',      icon: '\uD83D\uDC56' },
        { label: 'Maternity Pants',     desc: 'Smart, stretchy pants for work and everyday wear.',         url: '/collections/maternity-pants',      icon: '\uD83D\uDC54' },
        { label: 'Maternity Dresses',   desc: 'Flowy & flattering styles for your growing bump.',          url: '/collections/maternity-dresses',    icon: '\uD83D\uDC57' },
        { label: 'Baby Shower Dresses', desc: 'Look stunning at your baby shower celebration.',            url: '/collections/baby-shower-dresses',  icon: '\uD83C\uDF80' },
      ],
      t3: [
        { label: 'Photoshoot Gowns',    desc: 'Gorgeous gowns to capture this beautiful moment.',          url: '/collections/photoshoot-dresses',   icon: '\uD83D\uDCF8' },
        { label: 'Baby Shower Dresses', desc: 'Celebrate in style during your third trimester.',           url: '/collections/baby-shower-dresses',  icon: '\uD83C\uDF80' },
        { label: 'Nursing Dresses',     desc: 'Prepare for after birth with nursing-friendly styles.',     url: '/collections/nursing-dresses',      icon: '\uD83E\uDD31' },
        { label: 'Delivery Robes',      desc: 'Comfortable, stylish robes for your hospital stay.',        url: '/collections/delivery-robes',       icon: '\uD83C\uDFE5' },
      ],
    };

    var recsList = weeksPreg < 14 ? recsData.t1 : weeksPreg < 28 ? recsData.t2 : recsData.t3;
    var recsEl   = document.getElementById('ddc-recs');
    var recsGrid = document.getElementById('ddc-recs-grid');

    recsGrid.innerHTML = recsList.map(function (r) {
      return '<a class="ddc-rec-card" href="' + r.url + '">'
        + '<span class="ddc-rec-icon">' + r.icon + '</span>'
        + '<span class="ddc-rec-label">' + r.label + '</span>'
        + '<span class="ddc-rec-desc">' + r.desc + '</span>'
        + '<span class="ddc-rec-link">Shop now \u2192</span>'
        + '</a>';
    }).join('');
    recsEl.hidden = daysFromLmp < 0;

    var resultEl = document.getElementById('ddc-result');
    resultEl.hidden = false;
    resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  function ddcAlert(msg) {
    var el = document.createElement('div');
    el.setAttribute('role', 'alert');
    el.setAttribute('aria-live', 'assertive');
    el.style.cssText = 'position:fixed;top:1rem;left:50%;transform:translateX(-50%);background:#e95144;color:#fff;padding:12px 20px;border-radius:8px;font-size:.9rem;z-index:9999;box-shadow:0 4px 16px rgba(0,0,0,.15);max-width:90vw;text-align:center;';
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 3000);
  }

})();